module.exports = __webpack_public_path__ + "static/media/rollkall_default.478b61f2.svg";